import { Icon, IconProps } from '@elkaso-app/web-design';

export const BreadcrumbIcon = (props: IconProps) => {
  return (
    <Icon width='20px' height='20px' viewBox='0 0 20 20' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z'
        fill='#E2E3ED'
      />
    </Icon>
  );
};
